import { SelectedSalesItemsCar } from 'noddi-types';

import { SalesItemWheelsPickupOptionRecordArray } from '@navio/nsdk';
import { TireHotelMultipleCars } from './TireHotelMultipleCars';

type Props = {
  carsWithTirePickupOptions: SelectedSalesItemsCar[];
  pickUpOptions: SalesItemWheelsPickupOptionRecordArray;
};

export const MultipleCarsWithPickUpOptions = ({ pickUpOptions, carsWithTirePickupOptions }: Props) => {
  const sortedPickUpOptions = [...pickUpOptions].sort((a, b) => a.uiSortOrder - b.uiSortOrder);

  return (
    <div className='flex flex-col gap-4'>
      {sortedPickUpOptions.map((pickUpSalesItem) => (
        <TireHotelMultipleCars
          tireHotelSalesItem={pickUpSalesItem}
          carsWithTirePickupOptions={carsWithTirePickupOptions}
          key={pickUpSalesItem.salesItemId}
        />
      ))}
    </div>
  );
};
